import * as React from 'react';
import { Link } from "react-router-dom";
import { MedicineForListModel } from "../../models";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown, faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';
import Translate from '../../common/functions/translate';

const medicinesList = (props) => {

	const listItems =
		props.isTopList ?
			props.medicines.map((m: MedicineForListModel) =>
				<li key={m.medicineId}>
					<Link to={'/medicines/' + m.medicineId}>
						{m.brandName ? m.brandName : ''}
						{m.additionalTitle ?
							' - ' + (m.additionalTitle.length > 30 ? m.additionalTitle.substr(0, 30) + '...' : m.additionalTitle)
							: ''}
					</Link>
				</li>)
			:
			props.medicines.map((m: MedicineForListModel) =>
				<li key={m.medicineId} onClick={(e) =>
					props.history.push('/medicines/' + m.medicineId)
				}>
					<div>
						<div className="badge-container">
							<div className="badge big unknown">
								{m.brandName ? m.brandName.charAt(0) : '?'}
							</div>
						</div>
					</div>
					<div className="item-info">
						<div className="item-name">
							{m.brandName ? m.brandName : ''}
						</div>
						<div className="item-desc">
							{m.additionalTitle ?
								m.additionalTitle
								//m.additionalTitle.length > 25 ? m.additionalTitle.substr(0, 50) + '...' : m.additionalTitle
								: ''}
							<div>
								{m.activeIngredientName ? Translate('GenericName') + ": " + m.activeIngredientName : null}
							</div>
						</div>
					</div>
					<div className="item-actions">
						<FontAwesomeIcon icon={faChevronRight} />
					</div>

				</li>);

	return (
		props.isTopList ?
			<ul className="medicine-list-column">
				{listItems}
			</ul> :
			<ul className="list-items">
				{listItems}
			</ul>
	)
}

export default medicinesList;
